"use strict";

document.addEventListener('DOMContentLoaded', function () {

    // Fallback for the prototype (DE)
    const splideI18nDefault = {
        prev: 'Vorheriger Slide',
        next: 'Nächster Slide',
        first: 'Erster Slide',
        last: 'Letzter Slide',
        slideX: 'Gehe zu Slide %s',
        pageX: 'Gehe zu Seite %s',
        play: 'Autoplay starten',
        pause: 'Autoplay pausieren',
        carousel: 'Slider',
        slide: 'Slide',
        select: 'Wähle einen Slide zum Anzeigen',
    };

    // Logic for initialization (Merging of defaults and MODX overrides)
    const i18nConfig = Object.assign({}, splideI18nDefault, window.splideL10n || {});



    // * * * * * * * * * * * * * * * * * * * * * * * * * 
    // * splide heroSlider
    // *
    // *

    const heroSlider = document.getElementsByClassName('js-hero-slider');

    if (heroSlider !== null) {
        for (let i = 0; i < heroSlider.length; i++) {
            new Splide(heroSlider[i], {
                type: 'fade',
                pauseOnHover: true,
                rewind: true,
                lazyLoad: 'nearby',
                i18n: i18nConfig
            }).mount();
        }
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * splide textSlider
    // *
    // *

    const textSlider = document.getElementsByClassName('js-text-slider');

    if (textSlider !== null) {
        for (let i = 0; i < textSlider.length; i++) {
            new Splide(textSlider[i], {
                type: 'slide',
                rewind: true,
                arrows: true,
                pagination: true,
                lazyLoad: 'nearby',
                perPage: 1,
                gap: '3rem',
                i18n: i18nConfig,
                breakpoints: {
                    768: {
                        perPage: 1,
                    }
                }
            }).mount();
        }
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * splide testimonial
    // *
    // *

    const testimonialSlider = document.getElementsByClassName('js-testimonial');

    if (testimonialSlider !== null) {
        for (let i = 0; i < testimonialSlider.length; i++) {
            let container = testimonialSlider[i];
            let splide = new Splide(container, {
                type: 'loop',
                arrows: true,
                pagination: true,
                perPage: 1,
                gap: '20px',
                rewind: true,
                i18n: i18nConfig
            });

            splide.mount();
        }
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * splide teamSlider
    // *
    // *

    const teamSlider = document.getElementsByClassName('js-teamslider');

    if (teamSlider !== null) {
        for (let i = 0; i < teamSlider.length; i++) {
            let container = teamSlider[i];
            let splide = new Splide(container, {
                type: 'loop',
                arrows: true,
                pagination: true,
                perPage: 1,
                gap: '20px',
                rewind: true,
                i18n: i18nConfig
            });

            splide.mount();
        }
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * slider gallery (scroll-triggered horizontal scroll)
    // *
    // *

    const sliderGalleries = document.querySelectorAll('.js-slidergallery');

    if (sliderGalleries.length > 0) {
        sliderGalleries.forEach(gallery => {
            const track = gallery.querySelector('.js-slidergallery-track');
            if (!track) return;

            const updateGalleryScroll = () => {
                const rect = gallery.getBoundingClientRect();
                const galleryHeight = gallery.offsetHeight;
                const viewportHeight = window.innerHeight;

                // Calculate scroll progress: 0 (top enters viewport) to 1 (bottom leaves viewport)
                const scrollDistance = galleryHeight - viewportHeight;
                const scrolled = -rect.top;
                const progress = Math.max(0, Math.min(1, scrolled / scrollDistance));

                // Calculate how far the track needs to move
                const trackWidth = track.scrollWidth;
                const visibleWidth = window.innerWidth;
                const maxTranslate = trackWidth - visibleWidth;

                track.style.transform = `translateX(${-progress * maxTranslate}px)`;

                requestAnimationFrame(updateGalleryScroll);
            };

            requestAnimationFrame(updateGalleryScroll);
        });
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * scrollTo
    // *
    // *

    const anchorSelectors = ".js-scrollTo, .skiplink";
    const anchors = document.querySelectorAll(anchorSelectors);

    function clickHandler(e) {
        e.preventDefault();

        const href = this.getAttribute("href");
        if (!href || !href.includes("#")) return;

        const targetId = href.split("#")[1];
        let targetElement = document.getElementById(targetId) || document.getElementById("my" + targetId);

        let offset = 0;
        const anchorNav = this.closest('.js-anchor-nav');
        if (anchorNav) {
            offset = anchorNav.offsetHeight;
        }

        if (targetElement) {
            let offsetTop = targetElement.offsetTop - offset;

            // Add extra offset if it's a skiplink AND the header is actually fixed/sticky
            const header = document.querySelector('.js-header');
            if (header && this.classList.contains('skiplink')) {
                const headerStyle = window.getComputedStyle(header);
                const isPinned = headerStyle.position === 'fixed' || headerStyle.position === 'sticky';
                
                if (isPinned) {
                    offsetTop -= header.offsetHeight;
                }
            }

            window.scrollTo({
                top: targetId === 'footer' ? document.documentElement.scrollHeight : offsetTop,
                behavior: "smooth"
            });

            // Set focus for accessibility
            targetElement.focus({ preventScroll: true });
        }
    }

    for (const anchor of anchors) {
        anchor.addEventListener("click", clickHandler);
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * hash link jump to content
    // *
    // *

    window.addEventListener('load', function () {
        const hash = window.location.hash;
        if (!hash) return;

        const targetId = hash.slice(1);
        const targetElement = document.getElementById(targetId) || document.getElementById("my" + targetId);

        if (targetElement) {
            // Wait a bit for other lazy-loaded components if necessary
            setTimeout(() => {
                window.scrollTo({
                    top: targetId === 'footer' ? document.documentElement.scrollHeight : targetElement.offsetTop,
                    behavior: "smooth"
                });
                targetElement.focus({ preventScroll: true });
            }, 100);
        }
    }, false);



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * header scroll effect
    // *
    // *

    const header = document.querySelector('.js-header');
    const heroAreaEl = document.querySelector('.heroArea');
    
    if (header !== null) {
        document.addEventListener('scroll', function (e) {
            // Offset by heroArea height so header only reacts when real content scrolls
            const heroOffset = heroAreaEl ? heroAreaEl.offsetHeight - window.innerHeight : 0;
            const effectiveScroll = window.scrollY - heroOffset;

            if (effectiveScroll > 50) {
                header.classList.add('is-scrolled');
            } else {
                header.classList.remove('is-scrolled');
            }
        });
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * main navigation toggle
    // *
    // *

    const hamburgerBtn = document.querySelector('.js-hamburger');
    const mainNav = document.querySelector('.js-nav');
    const headerElement = document.querySelector('.js-header');

    if (hamburgerBtn !== null && mainNav !== null) {
        hamburgerBtn.addEventListener('click', function () {
            let expanded = this.getAttribute('aria-expanded');
            
            if (expanded === 'true') {
                this.setAttribute('aria-expanded', 'false');
                mainNav.classList.remove('is-open');
                mainNav.setAttribute('aria-hidden', 'true');
                if(headerElement) {
                    headerElement.classList.remove('nav-is-open');
                }
                document.body.classList.remove('nav-is-open');
            } else {
                this.setAttribute('aria-expanded', 'true');
                mainNav.classList.add('is-open');
                mainNav.setAttribute('aria-hidden', 'false');
                if(headerElement) {
                    headerElement.classList.add('nav-is-open');
                }
                document.body.classList.add('nav-is-open');
            }
        });
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * image tooltip interaction
    // *
    // *

    const tooltipItems = document.querySelectorAll('.js-tooltip-item');
    const tooltipTarget = document.querySelector('.js-tooltip-target');

    if (tooltipItems.length > 0) {
        document.addEventListener('click', function(e) {
            let isInsideTooltip = e.target.closest('.js-tooltip-item');
            let isInsideNav = e.target.closest('.imageTooltip__mobileNav');

            if (!isInsideTooltip && !isInsideNav) {
                tooltipItems.forEach(i => {
                    i.classList.remove('is-active');
                    const dot = i.querySelector('.imageTooltip__dot');
                    if (dot) dot.setAttribute('aria-expanded', 'false');
                });
                
                if (tooltipTarget) {
                    tooltipTarget.classList.remove('is-filled');
                    setTimeout(() => { tooltipTarget.innerHTML = ''; }, 300); // Wait for transition
                }
            }
        });

        tooltipItems.forEach(item => {
            const dot = item.querySelector('.imageTooltip__dot');
            const content = item.querySelector('.js-tooltip-content');

            if (dot) {
                dot.addEventListener('click', function(e) {
                    e.preventDefault();
                    
                    const wasActive = item.classList.contains('is-active');

                    // Close all others
                    tooltipItems.forEach(i => {
                        i.classList.remove('is-active');
                        const innerDot = i.querySelector('.imageTooltip__dot');
                        if (innerDot) innerDot.setAttribute('aria-expanded', 'false');
                    });
                    
                    if (tooltipTarget) {
                        tooltipTarget.classList.remove('is-filled');
                    }

                    // Open clicked
                    if (!wasActive) {
                        item.classList.add('is-active');
                        this.setAttribute('aria-expanded', 'true');

                        // Copy content downward for mobile view
                        if (window.innerWidth < 992 && tooltipTarget && content) {
                            tooltipTarget.innerHTML = content.innerHTML;
                            tooltipTarget.classList.add('is-filled');
                        }
                    }
                });
            }
        });

        window.addEventListener('resize', function() {
            if (window.innerWidth >= 992 && tooltipTarget && tooltipTarget.classList.contains('is-filled')) {
                tooltipTarget.classList.remove('is-filled');
                tooltipTarget.innerHTML = '';
            } else if (window.innerWidth < 992 && tooltipTarget && !tooltipTarget.classList.contains('is-filled')) {
                const activeItem = document.querySelector('.js-tooltip-item.is-active .js-tooltip-content');
                if (activeItem) {
                    tooltipTarget.innerHTML = activeItem.innerHTML;
                    tooltipTarget.classList.add('is-filled');
                }
            }
        });

        // Mobile prev/next navigation
        const tooltipPrev = document.querySelector('.js-tooltip-prev');
        const tooltipNext = document.querySelector('.js-tooltip-next');

        const activateTooltipItem = (index) => {
            tooltipItems.forEach(i => {
                i.classList.remove('is-active');
                const d = i.querySelector('.imageTooltip__dot');
                if (d) d.setAttribute('aria-expanded', 'false');
            });
            if (tooltipTarget) tooltipTarget.classList.remove('is-filled');

            const item = tooltipItems[index];
            if (!item) return;
            item.classList.add('is-active');
            const dot = item.querySelector('.imageTooltip__dot');
            if (dot) dot.setAttribute('aria-expanded', 'true');

            const content = item.querySelector('.js-tooltip-content');
            if (tooltipTarget && content && window.innerWidth < 992) {
                tooltipTarget.innerHTML = content.innerHTML;
                tooltipTarget.classList.add('is-filled');
            }
        };

        const getCurrentIndex = () => {
            let idx = -1;
            tooltipItems.forEach((item, i) => { if (item.classList.contains('is-active')) idx = i; });
            return idx;
        };

        if (tooltipPrev && tooltipNext) {
            if (window.innerWidth < 992) activateTooltipItem(0);

            tooltipPrev.addEventListener('click', () => {
                if (window.innerWidth >= 992) return;
                const idx = getCurrentIndex();
                activateTooltipItem(idx <= 0 ? tooltipItems.length - 1 : idx - 1);
            });

            tooltipNext.addEventListener('click', () => {
                if (window.innerWidth >= 992) return;
                const idx = getCurrentIndex();
                activateTooltipItem(idx >= tooltipItems.length - 1 ? 0 : idx + 1);
            });

            window.addEventListener('resize', () => {
                if (window.innerWidth < 992 && getCurrentIndex() === -1) activateTooltipItem(0);
            });
        }
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * scrollToTop
    // *
    // *

    const scrolltotop = document.querySelector(".js-scrolltop");

    if (scrolltotop !== null) {
        // show and hide scrollToTop btn on scroll
        document.addEventListener('scroll', function (e) {
            // Offset by heroArea height so button only appears when real content scrolls
            const heroAreaOffset = heroAreaEl ? heroAreaEl.offsetHeight - window.innerHeight : 0;
            const effectiveScroll = window.scrollY - heroAreaOffset;

            if (effectiveScroll > 300) {
                scrolltotop.classList.add("show");
            } else {
                scrolltotop.classList.remove("show");
            }
        });

        // onclick scroll to top
        scrolltotop.onclick = function (e) {
            e.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }

        // onkeydown scroll to top or bottom
        scrolltotop.addEventListener("keydown", function (event) {
            if (event.keyCode === 13 || event.keyCode === 32) {
                event.preventDefault();

                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }
        });
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * anchor nav scrollTo
    // *
    // *

    // get browser width
    let browserWidth = window.innerWidth;
    let anchorBox = document.querySelector('.js-anchor-nav');
    let anchorBoxSticky = document.querySelector('.js-anchor-sticky');

    // check if anchor modul is set to sticky
    if (anchorBoxSticky !== null) {
        window.addEventListener('scroll', function (e) {
            // get pos from anchorbox
            let pos = Math.round(anchorBox.getBoundingClientRect().y);

            if (pos <= 0) {
                anchorBox.classList.add("stick");
            } else {
                anchorBox.classList.remove("stick");
            }
        });
    }

    // check if anchor modul is set
    if (anchorBox !== null) {
        // needed for sticky anchor to calculate offsetTop
        anchorBoxHeight = anchorBox.offsetHeight;

        if (browserWidth > 1280) {
            anchorBoxHeight = anchorBoxHeight;
        } else {
            anchorBoxHeight = 0;
        }

        const anchors = anchorBox.querySelectorAll(".js-scrollTo");

        for (const anchor of anchors) {
            anchor.addEventListener("click", clickHandler);
        }
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * modal window
    // *
    // *

    let modalWindow = document.querySelector(".js-modal");
    let modalOpenButtons = document.querySelectorAll(".js-modal-btn-open");
    let modalClose = document.querySelector(".js-modal-btn-close");

    /* hide sidebar buttons if no modal exists on this page */
    if (!modalWindow) {
        modalOpenButtons.forEach(btn => {
            const parentItem = btn.closest('.sidebar__item');
            if (parentItem) {
                parentItem.classList.add('is-hidden');
            }
        });
    }

    /* function to handle modal closing */
    const closeModal = () => {
        if (modalWindow && typeof modalWindow.close === "function") {
            modalWindow.close();
        } else if (modalWindow) {
            modalWindow.style.display = "none";
        }
        document.body.classList.remove('freeze');
        
        // Show all hidden sidebar items again
        document.querySelectorAll('.sidebar__item.is-hidden').forEach(item => {
            item.classList.remove('is-hidden');
        });
    };

    /* onclick show modal window */
    if (modalOpenButtons.length > 0 && modalWindow) {
        modalOpenButtons.forEach(btn => {
            btn.onclick = function (e) {
                e.preventDefault();
                if (typeof modalWindow.showModal === "function") {
                    modalWindow.showModal();
                } else {
                    modalWindow.style.display = "block";
                }
                modalWindow.focus();
                document.body.classList.add('freeze');

                // Hide the parent sidebar item if it exists
                const parentItem = btn.closest('.sidebar__item');
                if (parentItem) {
                    parentItem.classList.add('is-hidden');
                }
            }
        });
    }

    /* close modal window */
    if (modalClose !== null) {
        modalClose.onclick = closeModal;
    }

    /* clicks anywhere outside close modal window */
    window.onclick = function (event) {
        if (event.target == modalWindow) {
            closeModal();
        }
    }

    /* native close event (e.g. via ESC key) */
    if (modalWindow !== null) {
        modalWindow.addEventListener('close', function() {
            document.body.classList.remove('freeze');
        });
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * accordion open every tab
    // *
    // *

    const accordionTitles = document.querySelectorAll(".js-accordion-title");

    if (accordionTitles.length > 0) {
        accordionTitles.forEach(title => {
            title.addEventListener('click', function (e) {
                this.classList.toggle("open");
                
                const controlsId = this.getAttribute('aria-controls');
                if (controlsId) {
                    const contentElement = document.getElementById(controlsId);
                    if (contentElement) {
                        contentElement.classList.toggle("open");
                    }
                }

                const expanded = this.getAttribute('aria-expanded');
                if (expanded === 'false') {
                    this.setAttribute('aria-expanded', 'true');
                } else {
                    this.setAttribute('aria-expanded', 'false');
                }
            });
        });
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * open external links in new tab
    // *
    // *

    function externalLinks() {
        for (let links = document.getElementsByTagName("a"), number = 0; number < links.length; number++) {
            let currentLink = links[number];

            // check if link has same hostname. if not add target blank.
            currentLink.getAttribute("href") && currentLink.hostname !== location.hostname && (currentLink.target = "_blank")
        }
    };

    externalLinks();




    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * native parallax replacement
    // *
    // *

    const initParallax = () => {
        const parallaxImages = document.querySelectorAll('.js-parallax');
        if (parallaxImages.length === 0) return;

        const observerOptions = {
            threshold: 0,
            rootMargin: "0px"
        };

        const parallaxObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.dataset.visible = "true";
                } else {
                    entry.target.dataset.visible = "false";
                }
            });
        }, observerOptions);

        parallaxImages.forEach(img => {
            parallaxObserver.observe(img);
            // set initial scale to have some buffer for moving
            img.style.transform = "scale(1.2) translateY(0px)";
        });

        const updateParallax = () => {
            parallaxImages.forEach(img => {
                if (img.dataset.visible === "true") {
                    const rect = img.getBoundingClientRect();
                    const windowHeight = window.innerHeight;
                    const elementHeight = rect.height;
                    const elementCenter = rect.top + elementHeight / 2;
                    const viewportCenter = windowHeight / 2;

                    // calculate distance from center of viewport (-1 to 1)
                    const distance = (elementCenter - viewportCenter) / (windowHeight / 2 + elementHeight / 2);
                    const movement = distance * 50; // shift by 50px max

                    img.style.transform = `scale(1.2) translateY(${movement}px)`;
                }
            });
            requestAnimationFrame(updateParallax);
        };

        requestAnimationFrame(updateParallax);
    };

    initParallax();



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * native aos replacement (Intersection Observer)
    // *
    // *

    const aosElements = document.querySelectorAll('[data-aos]');

    const observerOptions = {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px"
    };

    const aosObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('aos-animate');
                if (entry.target.getAttribute('data-aos-once') !== 'false') {
                    observer.unobserve(entry.target);
                }
            } else {
                if (entry.target.getAttribute('data-aos-once') === 'false') {
                    entry.target.classList.remove('aos-animate');
                }
            }
        });
    }, observerOptions);

    aosElements.forEach(element => {
        aosObserver.observe(element);
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * mouse parallax for bgsnake
    // *
    // *

    const snakeContainers = document.querySelectorAll('.content--bgsnake');

    if (snakeContainers.length > 0) {
        snakeContainers.forEach(container => {
            container.addEventListener('mousemove', (e) => {
                const rect = container.getBoundingClientRect();
                
                // Calculate mouse position relative to container center
                // Value between -1 and 1
                const x = (e.clientX - rect.left - (rect.width / 2)) / (rect.width / 2);
                const y = (e.clientY - rect.top - (rect.height / 2)) / (rect.height / 2);
                
                // Move in *opposite* direction, max 3% to keep it subtle
                // We set absolute max transform in scss via vars
                const moveX = x * -3; 
                const moveY = y * -3;

                // Set CSS variables for SCSS transform handling
                container.style.setProperty('--mouse-x', `${moveX}%`);
                container.style.setProperty('--mouse-y', `${moveY}%`);
            });

            // Reset back to center when mouse leaves
            container.addEventListener('mouseleave', () => {
                container.style.setProperty('--mouse-x', '0%');
                container.style.setProperty('--mouse-y', '0%');
            });
        });
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * snake text animation
    // *
    // *

    const snakeTextPathDesktop = document.querySelector('.js-snake-text-desktop');
    const snakeTextPathMobile = document.querySelector('.js-snake-text-mobile');
    const snakeHeroSection = document.querySelector('.js-snake-section');
    const snakeOverlay = document.querySelector('.snake');

    if ((snakeTextPathDesktop || snakeTextPathMobile) && snakeHeroSection) {
        const STOP_PROGRESS = 0.65;  // text stops moving at left edge at this scroll progress
        const FADE_START_PROGRESS = 0.72; // fade out begins here (after text has rested)

        const updateSnake = () => {
            const rect = snakeHeroSection.getBoundingClientRect();
            const sectionHeight = rect.height;
            const viewportHeight = window.innerHeight;

            // Calculate how much of the hero section is "active" for pinning
            const scrollDistance = sectionHeight - viewportHeight;
            const scrollProgress = Math.max(0, Math.min(-rect.top / scrollDistance, 1));

            let startVal = 70;
            let endVal = 38; // stop position at left viewport edge

            if (window.innerWidth <= 480) {
                startVal = 55;
                endVal = 2;
            } else if (window.innerWidth <= 768) {
                startVal = 60;
                endVal = 5;
            } else if (window.innerWidth <= 1024) {
                startVal = 65;
                endVal = 32;
            }

            // Phase 1: text slides in; Phase 2: text frozen at endVal
            const normalizedProgress = Math.min(scrollProgress / STOP_PROGRESS, 1);
            const calculatedOffset = startVal - (normalizedProgress * (startVal - endVal));

            // Fade in at the beginning (only mobile), fade out after text stops (all devices)
            let snakeOpacity = 1;

            if (window.innerWidth <= 1024) {
                if (scrollProgress < 0.15) {
                    snakeOpacity = scrollProgress / 0.15; // fades from 0 to 1
                }
            }

            if (scrollProgress > FADE_START_PROGRESS) {
                snakeOpacity = 1 - ((scrollProgress - FADE_START_PROGRESS) / (1 - FADE_START_PROGRESS)); // fades from 1 to 0
            }

            requestAnimationFrame(() => {
                if (snakeTextPathDesktop) snakeTextPathDesktop.setAttribute('startOffset', calculatedOffset + '%');
                if (snakeTextPathMobile) snakeTextPathMobile.setAttribute('startOffset', calculatedOffset + '%');

                if (snakeOverlay) {
                    snakeOverlay.style.opacity = snakeOpacity;
                }
            });
        };

        window.addEventListener('scroll', updateSnake);
        window.addEventListener('resize', updateSnake);
        updateSnake(); // initial call
    }


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * circleTeaser toggle logic
    // *
    // * Toggle is-active class on click/tap for better mobile experience
    // *

    const teaserCards = document.querySelectorAll('.js-circle-teaser-card');

    if (teaserCards.length > 0) {
        teaserCards.forEach(card => {
            const toggleTeaser = (e) => {
                e.preventDefault();
                
                const isActive = card.classList.contains('is-active');

                // Close all other teasers
                teaserCards.forEach(otherCard => otherCard.classList.remove('is-active'));

                // Toggle this one
                if (!isActive) {
                    card.classList.add('is-active');
                }
            };

            card.addEventListener('click', toggleTeaser);
            
            // Keyboard support
            card.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    toggleTeaser(e);
                }
            });
        });

        // Close teaser when clicking outside
        document.addEventListener('click', (e) => {
            if (!e.target.closest('.js-circle-teaser-card')) {
                teaserCards.forEach(card => card.classList.remove('is-active'));
            }
        });
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * lottie animations on viewport enter (play once)
    // *
    // *

    const lottieItems = document.querySelectorAll('.iconList__icon');

    if (lottieItems.length > 0) {
        const lottieObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const index = Array.from(lottieItems).indexOf(entry.target);
                    const player = entry.target.querySelector("lottie-player");
                    if (player) setTimeout(() => { player.stop(); player.play(); }, index * 150);
                }
            });
        }, { threshold: 0.3 });

        lottieItems.forEach(item => {
            if (item.querySelector("lottie-player")) {
                lottieObserver.observe(item);
            }
        });
    }
});
